<template>
    <div v-if="!!planningItem && !!quotes">
        <div style="margin-top: 10px">
            <div v-for="quote in quotes" :key="quote.quote_id">
                <div class="md-caption md-layout">
                    <div class="md-layout-item">Verkocht door:</div>
                    <div class="md-layout-item">{{ quote.sold_by_user ? quote.sold_by_user.first_name : '' }}</div>
                </div>
                <div class="md-caption md-layout">
                    <div class="md-layout-item">Offerte nummer:</div>
                    <div class="md-layout-item">{{ quote.quote_id }}</div>
                </div>
                <div class="md-caption md-layout">
                    <div class="md-layout-item">Creatie datum:</div>
                    <div class="md-layout-item">{{ moment(quote.creation_date).format('DD/MM/YYYY HH:mm:ss') }}</div>
                </div>
                <div class="md-caption md-layout">
                    <div class="md-layout-item">Offerte status:</div>
                    <div class="md-layout-item">{{ quote.status }}</div>
                </div>
                <div v-if="quote.quote_lines && quote.quote_lines.length" class="quote-lines">
                    <div class="md-caption md-layout quote-line-header">
                        <div class="md-layout-item md-size-45">Product</div>
                        <div class="md-layout-item md-size-15 quote-line-number">Aantal</div>
                        <div class="md-layout-item md-size-20 quote-line-number">Prijs</div>
                        <div class="md-layout-item md-size-20 quote-line-number">Totaal</div>
                    </div>
                    <div
                        v-for="line in quote.quote_lines"
                        :key="line.quote_line_id"
                        class="md-caption md-layout quote-line"
                    >
                        <div class="md-layout-item md-size-45">{{ lineName(line) }}</div>
                        <div class="md-layout-item md-size-15 quote-line-number">{{ line.quantity }}</div>
                        <div class="md-layout-item md-size-20 quote-line-number">
                            {{ line.unit_price !== null && line.unit_price !== undefined ? line.unit_price : '-' }}
                        </div>
                        <div class="md-layout-item md-size-20 quote-line-number">
                            {{
                                line.final_price_to_pay !== null && line.final_price_to_pay !== undefined
                                    ? line.final_price_to_pay
                                    : '-'
                            }}
                        </div>
                    </div>
                </div>
                <div class="md-caption md-layout">
                    <div class="md-layout-item">Sub total:</div>
                    <div class="md-layout-item">{{ quote.sub_total_price }}</div>
                </div>
                <div class="md-caption md-layout">
                    <div class="md-layout-item">Total:</div>
                    <div class="md-layout-item">{{ quote.final_price_to_pay }}</div>
                </div>
                <div class="md-caption md-layout">
                    <div class="md-layout-item">Rating</div>
                    <div class="md-layout-item">
                        <star-rating
                            :rating="rating ? rating.value : 0"
                            :read-only="true"
                            :max-rating="rating ? rating.max : 5"
                            :show-rating="false"
                            :star-size="10"
                        ></star-rating>
                    </div>
                </div>
                <div style="scale: 0.7; float: right">
                    <md-button
                        @click="editQuote(quote)"
                        class="md-accent md-raised md-dense"
                        :disabled="quote.status !== QuoteStatus.created"
                    >
                        <md-icon>edit</md-icon>
                        Edit
                    </md-button>
                    <md-button @click="downloadQuote(quote.quote_id)" class="md-accent md-raised md-dense">
                        <md-icon>vertical_align_bottom</md-icon>
                        Download
                    </md-button>
                </div>
                <div style="clear: both"></div>
                <md-divider></md-divider>
            </div>
            <div v-if="quotes.length === 0">Geen offertes beschikbaar</div>
        </div>
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import router from '@/router';
import * as toastr from 'toastr';
import * as moment from 'moment';
import {
    IPlanningItemEntity,
    IQuoteDataRating,
    IQuoteEntity,
    IQuoteLineEntity,
    PlanningItemType,
    PlanningState,
    QuoteApi,
    QuoteStatus,
} from '@phrospr/api-backend';
import StarRating from 'vue-star-rating';
import { downloadFileFromApi } from '@phrospr/lib-web-core';

@Component({
    components: { StarRating },
})
export default class PlanningDetailQuoteView extends Vue {
    public PlanningItemType = PlanningItemType;
    public PlanningState = PlanningState;
    public QuoteStatus = QuoteStatus;
    public moment = moment;

    get planningItem(): IPlanningItemEntity {
        return this.$store.state.planningItem;
    }
    get rating(): IQuoteDataRating {
        return this.$store.state.planningItem?.data?.rating;
    }

    get quotes(): IQuoteEntity[] {
        return this.$store.state.quotes;
    }

    public lineName(line: IQuoteLineEntity): string {
        if (line.product && line.product.name) return line.product.name;
        if (line.product_document_free_entry && line.product_document_free_entry.product_name) {
            return line.product_document_free_entry.product_name;
        }
        return '-';
    }

    public async downloadQuote(quote_id: number) {
        await downloadFileFromApi(await QuoteApi.downloadQuote(quote_id, { responseType: 'blob' }));
    }

    public async editQuote(quote: IQuoteEntity) {
        if (quote.status !== QuoteStatus.created) {
            return toastr.error('Quote is al goed gekeurd door klant, kan dit niet meer wijzigen');
        }
        if (quote.data && quote.data.quote_create) {
            this.$store.commit('setQuoteCreateSettings', {
                quote_id: quote.quote_id,
                editMode: true,
                client_id: quote.client_id,
            });
        } else {
            this.$store.commit('setQuoteCreateSettings', {
                quote_id: quote.quote_id,
                editMode: true,
                client_id: quote.client_id,
            });
            return router.push({ path: `/quote2/upsert/${quote.quote_id}` });
        }
        router.push({ path: `/quote?redirect_route=detail` });
    }
}
</script>

<style scoped>
#back-btn {
    /*float: right;*/
}

.comment-button {
    text-align: right;
}

.md-button[disabled] {
    opacity: 0.5;
}

#address-block {
    margin-top: 10px;
}

.quote-lines {
    margin: 8px 0;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 4px 6px;
}

.quote-line-header {
    font-weight: 600;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 2px;
}

.quote-line {
    padding: 2px 0;
}

.quote-line-number {
    text-align: right;
}
</style>
